import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../api';
import { IContactDetails } from './interface';

export const contactApi = createApi({
  reducerPath: 'contactApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    createContactMessage: builder.mutation<"", IContactDetails>({
      query: (body) => ({
        url: `/contact-us/`,
        method: 'POST',
        body: body
      }),
    }),
  }),
});

export const { useCreateContactMessageMutation } = contactApi;
